import { setToken } from "auth/VendorAuth/vendorUserSlice";
import axios from "axios";
import { useAppDispatch } from "hooks/redux";
import useSessionTimeout from "hooks/useSessionTimeout";
import { useContext } from "react";
import { AuthContext } from "react-oauth2-code-pkce";

const VendorSessionTimeout = () => {
  const dispatch = useAppDispatch();
  const { logOut } = useContext(AuthContext);

  const onLogout = () => {
    axios.post(`/api/v1/Account/logout`).finally(() => {
      logOut();
      dispatch(setToken(undefined));

      sessionStorage.removeItem("ROCP_tokenExpire");
      sessionStorage.removeItem("ROCP_refreshTokenExpire");
      sessionStorage.removeItem("ROCP_token");
      sessionStorage.removeItem("ROCP_idToken");
      sessionStorage.removeItem("PKCE_code_verifier");

      window.location.reload();
    });
  };
  useSessionTimeout(1200000, 300000, onLogout);
  return <></>;
};

export default VendorSessionTimeout;
